import {
  getDecorationOverrideColor,
  getDefaultIconColor
} from '~/selectors/ProductSelectors';
import {getIconsArray} from '~/selectors/CanvasSelectors';
import {changeColor} from './IconActions';

export function updateIconColorsBasedOnDecorationOverride(
  decoOverrideAppliedBefore
) {
  return (dispatch, getState) => {
    // Update color based on decoration override if applicable
    const newState = getState();
    // If no decoration override color is present but it was previously applied, we will just set the default color
    let newColor = getDecorationOverrideColor(newState);
    if (!newColor && decoOverrideAppliedBefore) {
      newColor = getDefaultIconColor(newState);
    }
    if (newColor) {
      const currentIcons = getIconsArray(newState);
      currentIcons.forEach(icon => {
        dispatch(changeColor({iconId: icon.id, color: newColor}));
      });
    }
  };
}
